export default "__VITE_ASSET__DX$xcN18__"